import styled from 'styled-components'

export const CatalogItemDetailsAnalysisStyled = styled.div`
  padding: ${(props) => props.theme.space.medium};
  border-radius: ${(props) => props.theme.typography.pxToRem(8)};
  background: ${(props) => props.theme.colors.alert.ai.background};
`
